import { render } from "./MoreBlogsBody.vue?vue&type=template&id=d6451000"
import script from "./MoreBlogsBody.vue?vue&type=script&lang=js"
export * from "./MoreBlogsBody.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__